import { useElasticData, useExtraData } from "../DataContext.js";

const AnnotationsPanel = ({tabIndex, sel}) => {

    let { productData } = useElasticData();
    
    let { _source, isGuestUser, isSchoolsUser, bookAwardsArray } = useExtraData();

    const name = `tab-${tabIndex}`;

    // Check if review & BOTW text match?
    const review = _source.evaluation?.trim();
    var botwText = _source.botw_review_any?.replace(/<[^>]+>/g, '');
    var specialCharacters =
    {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#039;': "'"
    };
    botwText = botwText?.replace(/&amp;|&lt;|&gt;|&quot;|&#039;/g, function(m) {return specialCharacters[m];});
    const reviewDoesNotMatchBOTW = (botwText != review);

    const newline = /\r\n|\r|\n/

    return(
        <div id={name} key={`tabindex${tabIndex}`} className={`tabContent ${name == sel ? "current" : ""}`}>
            <div className="columns wrap">
                <div className="noteSection">
                    <h4 className="titleText">Notes</h4>

                    {isSchoolsUser && productData.bwText != null && !!(productData.bwText) && <div className="textBlock">
                        <strong>Book of the week</strong>
                        <div dangerouslySetInnerHTML={{__html: productData.bwText}}></div>
                    </div>}

                    {isGuestUser && <><div className="loginRequired"><a className="login">Log in</a> to view our full review.</div><br /></>}
                    {isSchoolsUser && !isGuestUser && reviewDoesNotMatchBOTW && <div className="textBlock">
                        <strong>Our review</strong>
                        <p>{_source.evaluation ? _source.evaluation : "N/A"}</p>
                    </div>}

                    {(_source.annotation) && <div className="textBlock">
                        {isSchoolsUser && <strong>Summary</strong>}
                        <div className="bibTag">
                            <p>{_source.bib_tag}</p>
                            {_source.annotation && <br/>}
                        </div>
                        {_source.annotation && <p>{_source.annotation.split(newline).map((p, i, pp) => <span key={i}>{p}{i < pp.length - 1 && <><br/></>}</span>)}</p>}
                    </div>}

                    {isSchoolsUser && bookAwardsArray.length > 0 && <div className="textBlock">
                        <strong>Awards</strong>
                        <ul>
                            {bookAwardsArray.map((b, i) => <li key={i}>{b}</li>)}
                        </ul>
                    </div>}

                    {isSchoolsUser && _source.advisory_note && <div className="textBlock">
                        <strong>Content advisory</strong>
                        <p>{_source.advisory_note}</p>
                    </div>}
                </div>
                {!!(_source.contents) && <div className="noteSection">
                    <div className="textBlock">
                        <strong>Contents</strong>
                        <p>{_source.contents.split(/\n/).map((p, i, pp) => <span key={i}>{p}{i < pp.length - 1 && <><br/></>}</span>)}</p>
                    </div>    
                </div>}
            </div>
        </div>
    )
}

export default AnnotationsPanel;